 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "-" + {"chunk-0e45ab0a":"1f22bce0bfaf789031c1","chunk-ec435bf0":"83fc2d73fa2b27d35de6","chunk-1d82b74c":"8fde910c9ca822485a1c","chunk-20291322":"09d12b35290a22264e37","chunk-26858f3e":"d41496938293511d8571","chunk-18045af8":"dc2f6cad926bbcd3feba","chunk-2d0afe17":"3a8a9d73fbd91ec693ef","chunk-41957b65":"22e8f671b0881a38938a","chunk-606edaf3":"c016aa8b00bc8c835291","chunk-697cb670":"018cda81e6f17f6084af","chunk-6dbe746b":"6c6e7f675e274b5fd006","chunk-9e9c9b90":"dff03319a1024645712d","chunk-75c2a332":"0f51a7d418de2596801d","chunk-60f418d4":"639587575e4895c1f066","chunk-29c40494":"3381cfcc0e1335913dfb","chunk-2c9b8d06":"549cd63738cb737a4ba6","chunk-2cc50662":"d8eb0d13db01070a8895","chunk-2d0af8ad":"2c3a966194614a052821","chunk-2d0b614d":"bf1746dd98447c672b0c","chunk-2d0b6597":"97021eadb57fee07e4ea","chunk-2d0bd28f":"aa505b17bef825fa6b2e","chunk-2d0bda30":"5eacd0ffdb9dbc02be68","chunk-2d0bded9":"a6783a68d4c2aaab2ca8","chunk-2d0c4c28":"3130bf7f3c0d343a3b44","chunk-2d0d0647":"831a3ffeee139247096e","chunk-2d0d3c95":"2597eb1400688f364aaa","chunk-2d0d699d":"2ebc858d56703b762b41","chunk-2d0db0f7":"9784542d8336def3dd5f","chunk-2d0e5014":"f737d30e930fcbd4622f","chunk-2d0f0ff2":"829ef901eb2bbeb1a4cf","chunk-2d2082e3":"3128758c9a14f778a895","chunk-2d2102cc":"61448fc94562b2213ff7","chunk-2d21e953":"7f389d21af2f52704e81","chunk-2d224ec1":"c7acda14dbe33ec18c9c","chunk-2d2261e7":"f19955d95c015a6f9938","chunk-2d229415":"5e146e2eca87320717cd","chunk-2d23015d":"c97dae8c24648acee95e","chunk-2d2384c2":"ba94be85abccf7c6a6ae","chunk-42737dcc":"025dc8ab9d684fc2142a","chunk-1cb488af":"1d13d58ae4deb9922ba1","chunk-360a1575":"88ce65bf4d113196ec4b","chunk-7d0597e0":"d57dd570dce20048da27","chunk-c27c5b6c":"d5cd0962a448f4217ebc","chunk-86cd71ac":"17845028976c2b377b7d","chunk-68c3e0d7":"e139ac7fe35447ca720b","chunk-4b4cf850":"58998ffae43d21ad4b80","chunk-afa35d56":"dfbd3f2ef9fd6fda2d46","chunk-2d22d70b":"14a1dfd0cd42237f240c","chunk-38c3389e":"718d9214846320192c7e","chunk-118e7ef7":"22ef50aa7cc9a03a00c7","chunk-20356e7f":"ca8ebb20a6e8c66e7329","chunk-c7faf446":"6e1e69b3c49175ea242b","chunk-db6a3c98":"4fc828dc5e4d6719d3d1","chunk-17a450a2":"28e05215ae80f43cfb8d","chunk-791c521e":"9949830b9cbe3243c317","chunk-de40d9c6":"45cb949403f78779421e","chunk-fb960be4":"e1bf5c2250303cc91cc8","chunk-258ce8be":"db92586fbfb2db3db735","chunk-016a09d6":"a9a9f2c8a9d209ab50fd","chunk-b4238f60":"4e45aa68bdf3009b09de","chunk-2d0c5014":"356fdf5af08e8142d94f","chunk-4881a2bd":"a14e3f033b5a785e4b12","chunk-2d0a461c":"b65c48d2bf1d0f50e1ee","chunk-2d0a4990":"8ba0e082da86bfd131ec","chunk-2d0ab129":"7b968eface6a4edac815","chunk-2d0ac3b9":"f168447de8ba495f989c","chunk-2d0ae93b":"326eb859c3c3da0c9e96","chunk-2d0afa0c":"6581c7d0b21e774f1b3b","chunk-2d0bac39":"3558b3c873da47036648","chunk-2d0bceb3":"8e48536b8ef1dd982381","chunk-2d0c80c6":"4a5dfe20e18a0537266a","chunk-2d0d7469":"2018fbc49c9d9575831b","chunk-2d0e454b":"667742905bc33f9ade26","chunk-2d217358":"3d04905d63aa762923b0","chunk-2d21b490":"f32eea34111dfe584714","chunk-2d22c302":"ca7cfa64efbad4dc2164","chunk-2d22c58e":"fe1bcbffd2001b9de0fa","chunk-2d22d72d":"34513b7d5dd91623ae88","chunk-2d237c58":"b700a31807310f8d64bb","chunk-54b314c7":"5156b02960e0d4f72077","chunk-58884343":"4db262e02fba7921faf0","chunk-2d0deca7":"713d6ccd6db3e98e44ac","chunk-a1b39ab0":"592d343e0d9b1d603f1e","chunk-ab2f020a":"0408c5d5580d5aae864e","chunk-1695d452":"473cd58cfb3795d41f9f","chunk-584bbc38":"066eabc8af9845f8df20"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-75c2a332":1,"chunk-60f418d4":1,"chunk-29c40494":1,"chunk-1cb488af":1,"chunk-360a1575":1,"chunk-7d0597e0":1,"chunk-c27c5b6c":1,"chunk-38c3389e":1,"chunk-20356e7f":1,"chunk-c7faf446":1,"chunk-db6a3c98":1,"chunk-17a450a2":1,"chunk-791c521e":1,"chunk-258ce8be":1,"chunk-016a09d6":1,"chunk-b4238f60":1,"chunk-4881a2bd":1,"chunk-ab2f020a":1,"chunk-1695d452":1,"chunk-584bbc38":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "-" + {"chunk-0e45ab0a":"1f22bce0bfaf789031c1","chunk-ec435bf0":"83fc2d73fa2b27d35de6","chunk-1d82b74c":"8fde910c9ca822485a1c","chunk-20291322":"09d12b35290a22264e37","chunk-26858f3e":"d41496938293511d8571","chunk-18045af8":"dc2f6cad926bbcd3feba","chunk-2d0afe17":"3a8a9d73fbd91ec693ef","chunk-41957b65":"22e8f671b0881a38938a","chunk-606edaf3":"c016aa8b00bc8c835291","chunk-697cb670":"018cda81e6f17f6084af","chunk-6dbe746b":"6c6e7f675e274b5fd006","chunk-9e9c9b90":"dff03319a1024645712d","chunk-75c2a332":"0f51a7d418de2596801d","chunk-60f418d4":"639587575e4895c1f066","chunk-29c40494":"3381cfcc0e1335913dfb","chunk-2c9b8d06":"549cd63738cb737a4ba6","chunk-2cc50662":"d8eb0d13db01070a8895","chunk-2d0af8ad":"2c3a966194614a052821","chunk-2d0b614d":"bf1746dd98447c672b0c","chunk-2d0b6597":"97021eadb57fee07e4ea","chunk-2d0bd28f":"aa505b17bef825fa6b2e","chunk-2d0bda30":"5eacd0ffdb9dbc02be68","chunk-2d0bded9":"a6783a68d4c2aaab2ca8","chunk-2d0c4c28":"3130bf7f3c0d343a3b44","chunk-2d0d0647":"831a3ffeee139247096e","chunk-2d0d3c95":"2597eb1400688f364aaa","chunk-2d0d699d":"2ebc858d56703b762b41","chunk-2d0db0f7":"9784542d8336def3dd5f","chunk-2d0e5014":"f737d30e930fcbd4622f","chunk-2d0f0ff2":"829ef901eb2bbeb1a4cf","chunk-2d2082e3":"3128758c9a14f778a895","chunk-2d2102cc":"61448fc94562b2213ff7","chunk-2d21e953":"7f389d21af2f52704e81","chunk-2d224ec1":"c7acda14dbe33ec18c9c","chunk-2d2261e7":"f19955d95c015a6f9938","chunk-2d229415":"5e146e2eca87320717cd","chunk-2d23015d":"c97dae8c24648acee95e","chunk-2d2384c2":"ba94be85abccf7c6a6ae","chunk-42737dcc":"025dc8ab9d684fc2142a","chunk-1cb488af":"1d13d58ae4deb9922ba1","chunk-360a1575":"88ce65bf4d113196ec4b","chunk-7d0597e0":"d57dd570dce20048da27","chunk-c27c5b6c":"d5cd0962a448f4217ebc","chunk-86cd71ac":"17845028976c2b377b7d","chunk-68c3e0d7":"e139ac7fe35447ca720b","chunk-4b4cf850":"58998ffae43d21ad4b80","chunk-afa35d56":"dfbd3f2ef9fd6fda2d46","chunk-2d22d70b":"14a1dfd0cd42237f240c","chunk-38c3389e":"718d9214846320192c7e","chunk-118e7ef7":"22ef50aa7cc9a03a00c7","chunk-20356e7f":"ca8ebb20a6e8c66e7329","chunk-c7faf446":"6e1e69b3c49175ea242b","chunk-db6a3c98":"4fc828dc5e4d6719d3d1","chunk-17a450a2":"28e05215ae80f43cfb8d","chunk-791c521e":"9949830b9cbe3243c317","chunk-de40d9c6":"45cb949403f78779421e","chunk-fb960be4":"e1bf5c2250303cc91cc8","chunk-258ce8be":"db92586fbfb2db3db735","chunk-016a09d6":"a9a9f2c8a9d209ab50fd","chunk-b4238f60":"4e45aa68bdf3009b09de","chunk-2d0c5014":"356fdf5af08e8142d94f","chunk-4881a2bd":"a14e3f033b5a785e4b12","chunk-2d0a461c":"b65c48d2bf1d0f50e1ee","chunk-2d0a4990":"8ba0e082da86bfd131ec","chunk-2d0ab129":"7b968eface6a4edac815","chunk-2d0ac3b9":"f168447de8ba495f989c","chunk-2d0ae93b":"326eb859c3c3da0c9e96","chunk-2d0afa0c":"6581c7d0b21e774f1b3b","chunk-2d0bac39":"3558b3c873da47036648","chunk-2d0bceb3":"8e48536b8ef1dd982381","chunk-2d0c80c6":"4a5dfe20e18a0537266a","chunk-2d0d7469":"2018fbc49c9d9575831b","chunk-2d0e454b":"667742905bc33f9ade26","chunk-2d217358":"3d04905d63aa762923b0","chunk-2d21b490":"f32eea34111dfe584714","chunk-2d22c302":"ca7cfa64efbad4dc2164","chunk-2d22c58e":"fe1bcbffd2001b9de0fa","chunk-2d22d72d":"34513b7d5dd91623ae88","chunk-2d237c58":"b700a31807310f8d64bb","chunk-54b314c7":"5156b02960e0d4f72077","chunk-58884343":"4db262e02fba7921faf0","chunk-2d0deca7":"713d6ccd6db3e98e44ac","chunk-a1b39ab0":"592d343e0d9b1d603f1e","chunk-ab2f020a":"0408c5d5580d5aae864e","chunk-1695d452":"473cd58cfb3795d41f9f","chunk-584bbc38":"066eabc8af9845f8df20"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/docroot/mgnl-vue/dist/prod/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
